import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';
import {
  FDBodyText, FDDisplayText, FDHeadlineText, FDLozenge,
} from '@facet-wealth/design';
import {
  CustomizationToggle,
  RecommendationRationales, Products, FrequentlyAskedQuestions, QuestionsPicklist,
} from './Components';

const titleProps = { size: 'sm', color: 'textSecondary', align: 'center' };
const subtitleProps = { align: 'center' };
const descriptionProps = { size: 'md', align: 'center' };

export const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDDisplayText,
    _customProps: titleProps,
  }, overrideReadOnly)
  .override({ name: 'title', hint: 'richtext' }, {
    _component: () => Richtext,
    _customProps: { ...titleProps, Component: FDDisplayText },
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => FDHeadlineText,
    _customProps: subtitleProps,
  }, overrideReadOnly)
  .override({ name: 'title', hint: 'richtext' }, {
    _component: () => Richtext,
    _customProps: { ...subtitleProps, Component: FDHeadlineText },
  }, overrideReadOnly)
  .nameOverride('description', {
    _component: () => FDBodyText,
    _customProps: descriptionProps,
  }, overrideReadOnly)
  .override({ name: 'description', hint: 'richtext' }, {
    _component: () => Richtext,
    _customProps: { ...descriptionProps, Component: FDBodyText },
  }, overrideReadOnly)
  .nameOverride('question', {
    _component: () => FDBodyText,
    _customProps: descriptionProps,
  }, overrideReadOnly)
  .override({ name: 'question', hint: 'richtext' }, {
    _component: () => Richtext,
    _customProps: { ...descriptionProps, Component: FDBodyText },
  }, overrideReadOnly)
  .override({ name: 'addressInformationMissing' }, {
    _component: () => FDLozenge,
    _customProps: {
      color: 'warning',
      size: 'lg',
    },
  }, overrideReadOnly)
  .nameOverride('customDocument', { _component: () => CustomizationToggle }, overrideReadOnly)
  .nameOverride('products', { _component: () => Products }, overrideReadOnly)
  .nameOverride('frequentlyAskedQuestions', { _component: () => FrequentlyAskedQuestions }, overrideReadOnly)
  .nameOverride('recommendationRationale', { _component: () => RecommendationRationales }, overrideReadOnly)
  .nameOverride('questions', { _component: () => QuestionsPicklist }, overrideReadOnly);
